/* eslint-disable import/no-anonymous-default-export */
import React from 'react';

import { SuperAdminSettingContext } from './context';

const useSuperAdminSettingsContext = () => React.useContext(SuperAdminSettingContext);

export { useSuperAdminSettingsContext };
